import axiosClient from "./axiosClient";

const bot = {
    getBot: (id) => {
        const url = `bot/bot_settings/${id}`;
        return axiosClient.get(url);
    },
};
export default bot;
